// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"12cd3777","835":"444d7c8f","962":"a36def0d"}[chunkId] + ".chunk.js";
};